<script>
import UserStatus from '../../user/UserStatus.vue';

export default {
  name: 'AdminUserListStatusCell',
  components: { UserStatus },
  props: {
    row: Object,
  },
};
</script>

<template lang="pug">
  UserStatus.status(v-bind="row.status")
</template>

<style scoped lang="scss">
.status {
  width: 100%;
}
</style>
